export default {
    methods: {
        showRecaptcha(){
            document.onreadystatechange = () => {
               if (document.readyState == "complete") {
                    $('.grecaptcha-badge').css("z-index", window.screen.width < 640 ? 500 : 1000)
                    $('.grecaptcha-badge').css("visibility", "visible")
               }
           }
           $('.grecaptcha-badge').css("z-index", window.screen.width < 640 ? 500 : 1000)
           $('.grecaptcha-badge').css("visibility", "visible")
        },
        hideRecaptcha(){
            $('.grecaptcha-badge').css("z-index", -1)
            $('.grecaptcha-badge').css("visibility", "hidden")
        }
    },
    beforeDestroy(){
        this.hideRecaptcha()
    },
    mounted(){
        this.showRecaptcha()
    }
};
  